/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { useParams } from 'react-router-dom';
import { useStore } from '../../store';

import DownOutlined from '@ant-design/icons/lib/icons/DownOutlined';

interface ITopicItemProps {
  id: string;
  settings: [];
  className?: string;
}

const TopicItem: React.FunctionComponent<ITopicItemProps> = ({
  id,
  className,
  children,
  settings,
}) => {
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const { getParagraphState, courses, language } = useStore();

  const course = courses[p_course];
  const currentTopic = course.topics.find(
    (itm: { id: string }) => itm.id === p_topic
  );
  const paragraphState = getParagraphState(p_course, p_topic);
  const currParagraph = currentTopic.paragraphs.find(
    (itm: any) => itm.id === id
  );
  const currentIdx = currentTopic.paragraphs.indexOf(currParagraph);
  const lastParagraph = currentTopic.paragraphs[currentIdx - 1];
  const currParagraphState = paragraphState.find((itm) => itm.id === id);
  const lastParagraphState = paragraphState[currentIdx - 1];
  const nextParagraph = currentTopic.paragraphs[currentIdx + 1];
  const [displayMsg, setDisplayMsg] = React.useState(false);
  let msgTimeout = setTimeout(() => null);
  const preventToNext = () => {
    const component = currParagraphState?.components[0];
    const name = component.split('--')[1];
    document
      .querySelector(`.${name}`)
      ?.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
    clearTimeout(msgTimeout);
    msgTimeout = setTimeout(() => setDisplayMsg(false), 3000);
    setDisplayMsg(true);
  };
  return lastParagraph?.isRequired &&
    lastParagraphState?.state !== 'completed' ? null : (
    <div data-paragraph={id} className={className}>
      {children}
      {nextParagraph &&
      currParagraph?.isRequired &&
      currParagraphState?.state !== 'completed' ? (
        <div className="next-paragraph-bar" onClick={preventToNext}>
          <span>{nextParagraph?.title}</span>
          <DownOutlined />
        </div>
      ) : null}
      <div
        className={`prevent-msg-container animation 
        ${displayMsg ? 'fade-in' : ''}`}
      >
        <div className="prevent-msg">
          {language === 'tc' ? (
            <>請先查看{currParagraph.title}再繼續喔</>
          ) : language === 'sc' ? (
            <>请先查看{currParagraph.title}再继续喔</>
          ) : (
            <>Please check {currParagraph.title} before proceed</>
          )}
        </div>
      </div>
    </div>
  );
};

TopicItem.defaultProps = {
  className: '',
};
export default TopicItem;
